import Vue from 'vue'
import { Modal, Radio, Col, Tag, Table, Notification, Row, Icon, Menu, Divider, Button, Message, PageHeader, Tabs, Input, InputNumber, Select, Statistic, Empty, Alert, Spin, FormModel, Card, Layout, Popconfirm, Tooltip, Popover } from 'ant-design-vue'

Vue.use(Button)
Vue.use(Modal)
Vue.use(Radio)
Vue.use(PageHeader)
Vue.use(Input)
Vue.use(Popconfirm)
Vue.use(Select)
Vue.use(Statistic)
Vue.use(Empty)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Col)
Vue.use(Row)
Vue.use(FormModel)
Vue.use(Card)
Vue.use(Tabs)
Vue.use(Layout)
Vue.use(Divider)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Tag)
Vue.use(InputNumber)
Vue.use(Table)
Vue.use(Tooltip)
Vue.use(Popover)

Vue.prototype.$notification = Notification
Vue.prototype.$message = Message
Vue.prototype.$confirm = Modal.confirm
